export const PALETTES = [1, 2, 3, 4];

export const DEFAULT_OKLCH = {
  1: {
    hue: 10,
    low: 0.05,
    lowcenter: 0.075,
    center: 0.1,
    centerhigh: 0.09,
    high: 0.08,
  },
  2: {
    hue: 100,
    low: 0.05,
    lowcenter: 0.075,
    center: 0.1,
    centerhigh: 0.09,
    high: 0.08,
  },
  3: {
    hue: 190,
    low: 0.05,
    lowcenter: 0.075,
    center: 0.1,
    centerhigh: 0.09,
    high: 0.08,
  },
  4: {
    hue: 280,
    low: 0.008,
    lowcenter: 0.127,
    center: 0.241,
    centerhigh: 0.244,
    high: 0.145,
  },
}


export const DEFAULT_PALETTE = {
  1: {
    900: 98,
    800: 86,
    700: 74,
    600: 61,
    500: 49,
    400: 36,
    300: 20,
    200: 7,
    100: 0,
  },
  2: {
    900: 98,
    800: 86,
    700: 74,
    600: 61,
    500: 49,
    400: 36,
    300: 20,
    200: 7,
    100: 0,
  },
  3: {
    900: 98,
    800: 86,
    700: 74,
    600: 61,
    500: 49,
    400: 36,
    300: 20,
    200: 7,
    100: 0,
  },
  4: {
    900: 98,
    800: 86,
    700: 74,
    600: 61,
    500: 49,
    400: 36,
    300: 20,
    200: 7,
    100: 0,
  }
};

